
const msg =
{ 
    semConexao : 'Parece que você está sem internet! Recarregue a página!',
    semInformacaoSobreDebitoVeiculo : 'Ainda não temos informações sobre os débitos do veículo.'
}


export {msg}